import { DOMESTIC_NUTRITION_KEYS } from "./constants"

const PHILIPPINES_RENI_VALUES = {
  "1-2 years": {
    [DOMESTIC_NUTRITION_KEYS.ENERGY]: 1000,
    [DOMESTIC_NUTRITION_KEYS.PROTEIN]: 18,
    [DOMESTIC_NUTRITION_KEYS.TOTAL_FAT]: 16,
    [DOMESTIC_NUTRITION_KEYS.SODIUM]: 790,
    [DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE]: 7,
    [DOMESTIC_NUTRITION_KEYS.IRON]: 8,
    [DOMESTIC_NUTRITION_KEYS.CALCIUM]: 500,
    [DOMESTIC_NUTRITION_KEYS.FOLIC_ACID]: 90,
    [DOMESTIC_NUTRITION_KEYS.IODINE]: 90,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B6]: 0.5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B12]: 0.9,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_C]: 45,
    [DOMESTIC_NUTRITION_KEYS.ZINC]: 4.1,
    [DOMESTIC_NUTRITION_KEYS.MAGNESIUM]: 60,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_D]: 5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_K1]: 12,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B1]: 0.5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B2]: 0.5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B3]: 6,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_E]: 4,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_A]: 400,
    [DOMESTIC_NUTRITION_KEYS.SELENIUM]: 17,
    [DOMESTIC_NUTRITION_KEYS.POTASSIUM]: 1000,
    [DOMESTIC_NUTRITION_KEYS.CHLORIDE]: 350,
    [DOMESTIC_NUTRITION_KEYS.PHOSPHORUS]: 460,
  },

  "3-5 years": {
    [DOMESTIC_NUTRITION_KEYS.ENERGY]: 1350,
    [DOMESTIC_NUTRITION_KEYS.PROTEIN]: 22,
    [DOMESTIC_NUTRITION_KEYS.TOTAL_FAT]: 22,
    [DOMESTIC_NUTRITION_KEYS.SODIUM]: 1067,
    [DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE]: 10,
    [DOMESTIC_NUTRITION_KEYS.IRON]: 9,
    [DOMESTIC_NUTRITION_KEYS.CALCIUM]: 550,
    [DOMESTIC_NUTRITION_KEYS.FOLIC_ACID]: 120,
    [DOMESTIC_NUTRITION_KEYS.IODINE]: 90,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B6]: 0.6,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B12]: 1.1,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_C]: 45,
    [DOMESTIC_NUTRITION_KEYS.ZINC]: 5,
    [DOMESTIC_NUTRITION_KEYS.MAGNESIUM]: 70,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_D]: 5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_K1]: 18,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B1]: 0.5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B2]: 0.6,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B3]: 7,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_E]: 5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_A]: 400,
    [DOMESTIC_NUTRITION_KEYS.SELENIUM]: 20,
    [DOMESTIC_NUTRITION_KEYS.POTASSIUM]: 1400,
    [DOMESTIC_NUTRITION_KEYS.CHLORIDE]: 500,
    [DOMESTIC_NUTRITION_KEYS.PHOSPHORUS]: 500,
  },

  "6-9 years": {
    [DOMESTIC_NUTRITION_KEYS.ENERGY]: 1600,
    [DOMESTIC_NUTRITION_KEYS.PROTEIN]: 30,
    [DOMESTIC_NUTRITION_KEYS.TOTAL_FAT]: 26,
    [DOMESTIC_NUTRITION_KEYS.SODIUM]: 1264,
    [DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE]: 14,
    [DOMESTIC_NUTRITION_KEYS.IRON]: 10,
    [DOMESTIC_NUTRITION_KEYS.CALCIUM]: 700,
    [DOMESTIC_NUTRITION_KEYS.FOLIC_ACID]: 180,
    [DOMESTIC_NUTRITION_KEYS.IODINE]: 120,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B6]: 0.7,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B12]: 1.3,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_C]: 45,
    [DOMESTIC_NUTRITION_KEYS.ZINC]: 5.1,
    [DOMESTIC_NUTRITION_KEYS.MAGNESIUM]: 90,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_D]: 5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_K1]: 23,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B1]: 0.7,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B2]: 0.7,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B3]: 9,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_E]: 6,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_A]: 400,
    [DOMESTIC_NUTRITION_KEYS.SELENIUM]: 20,
    [DOMESTIC_NUTRITION_KEYS.POTASSIUM]: 1600,
    [DOMESTIC_NUTRITION_KEYS.CHLORIDE]: 600,
    [DOMESTIC_NUTRITION_KEYS.PHOSPHORUS]: 500,
  },

  "10-12 years": {
    [DOMESTIC_NUTRITION_KEYS.ENERGY]: 2060,
    [DOMESTIC_NUTRITION_KEYS.PROTEIN]: 43,
    [DOMESTIC_NUTRITION_KEYS.TOTAL_FAT]: 34,
    [DOMESTIC_NUTRITION_KEYS.SODIUM]: 1628,
    [DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE]: 17,
    [DOMESTIC_NUTRITION_KEYS.IRON]: 12,
    [DOMESTIC_NUTRITION_KEYS.CALCIUM]: 1000,
    [DOMESTIC_NUTRITION_KEYS.FOLIC_ACID]: 180,
    [DOMESTIC_NUTRITION_KEYS.IODINE]: 120,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B6]: 1,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B12]: 1.8,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_C]: 45,
    [DOMESTIC_NUTRITION_KEYS.ZINC]: 6.6,
    [DOMESTIC_NUTRITION_KEYS.MAGNESIUM]: 150,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_D]: 5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_K1]: 33,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B1]: 0.9,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B2]: 1,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B3]: 11,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_E]: 7,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_A]: 500,
    [DOMESTIC_NUTRITION_KEYS.SELENIUM]: 21,
    [DOMESTIC_NUTRITION_KEYS.POTASSIUM]: 2000,
    [DOMESTIC_NUTRITION_KEYS.CHLORIDE]: 750,
    [DOMESTIC_NUTRITION_KEYS.PHOSPHORUS]: 1250,
  },

  "13-15 years": {
    [DOMESTIC_NUTRITION_KEYS.ENERGY]: 2700,
    [DOMESTIC_NUTRITION_KEYS.PROTEIN]: 62,
    [DOMESTIC_NUTRITION_KEYS.TOTAL_FAT]: 45,
    [DOMESTIC_NUTRITION_KEYS.SODIUM]: 2134,
    [DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE]: 20,
    [DOMESTIC_NUTRITION_KEYS.IRON]: 19,
    [DOMESTIC_NUTRITION_KEYS.CALCIUM]: 1000,
    [DOMESTIC_NUTRITION_KEYS.FOLIC_ACID]: 240,
    [DOMESTIC_NUTRITION_KEYS.IODINE]: 150,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B6]: 1.3,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B12]: 2.3,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_C]: 60,
    [DOMESTIC_NUTRITION_KEYS.ZINC]: 9.2,
    [DOMESTIC_NUTRITION_KEYS.MAGNESIUM]: 220,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_D]: 5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_K1]: 49,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B1]: 1.2,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B2]: 1.3,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B3]: 15,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_E]: 10,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_A]: 500,
    [DOMESTIC_NUTRITION_KEYS.SELENIUM]: 30,
    [DOMESTIC_NUTRITION_KEYS.POTASSIUM]: 2000,
    [DOMESTIC_NUTRITION_KEYS.CHLORIDE]: 750,
    [DOMESTIC_NUTRITION_KEYS.PHOSPHORUS]: 1250,
  },

  "16-18 years": {
    [DOMESTIC_NUTRITION_KEYS.ENERGY]: 3010,
    [DOMESTIC_NUTRITION_KEYS.PROTEIN]: 72,
    [DOMESTIC_NUTRITION_KEYS.TOTAL_FAT]: 50,
    [DOMESTIC_NUTRITION_KEYS.SODIUM]: 2379,
    [DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE]: 23,
    [DOMESTIC_NUTRITION_KEYS.IRON]: 14,
    [DOMESTIC_NUTRITION_KEYS.CALCIUM]: 1000,
    [DOMESTIC_NUTRITION_KEYS.FOLIC_ACID]: 240,
    [DOMESTIC_NUTRITION_KEYS.IODINE]: 150,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B6]: 1.5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B12]: 2.7,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_C]: 70,
    [DOMESTIC_NUTRITION_KEYS.ZINC]: 9,
    [DOMESTIC_NUTRITION_KEYS.MAGNESIUM]: 265,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_D]: 5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_K1]: 59,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B1]: 1.4,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B2]: 1.5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B3]: 18,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_E]: 11,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_A]: 600,
    [DOMESTIC_NUTRITION_KEYS.SELENIUM]: 37,
    [DOMESTIC_NUTRITION_KEYS.POTASSIUM]: 2000,
    [DOMESTIC_NUTRITION_KEYS.CHLORIDE]: 750,
    [DOMESTIC_NUTRITION_KEYS.PHOSPHORUS]: 1250,
  },

  "19-29 yr old": {
    [DOMESTIC_NUTRITION_KEYS.ENERGY]: 2530,
    [DOMESTIC_NUTRITION_KEYS.PROTEIN]: 71,
    [DOMESTIC_NUTRITION_KEYS.TOTAL_FAT]: 42,
    [DOMESTIC_NUTRITION_KEYS.SODIUM]: 2000,
    [DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE]: 25,
    [DOMESTIC_NUTRITION_KEYS.IRON]: 12,
    [DOMESTIC_NUTRITION_KEYS.CALCIUM]: 750,
    [DOMESTIC_NUTRITION_KEYS.FOLIC_ACID]: 235,
    [DOMESTIC_NUTRITION_KEYS.IODINE]: 150,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B6]: 1.3,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B12]: 2.4,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_C]: 70,
    [DOMESTIC_NUTRITION_KEYS.ZINC]: 6.5,
    [DOMESTIC_NUTRITION_KEYS.MAGNESIUM]: 240,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_D]: 5,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_K1]: 61,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B1]: 1.2,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B2]: 1.3,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_B3]: 16,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_E]: 10,
    [DOMESTIC_NUTRITION_KEYS.SELENIUM]: 38,
    [DOMESTIC_NUTRITION_KEYS.POTASSIUM]: 2000,
    [DOMESTIC_NUTRITION_KEYS.CHLORIDE]: 750,
    [DOMESTIC_NUTRITION_KEYS.PHOSPHORUS]: 700,
    [DOMESTIC_NUTRITION_KEYS.VITAMIN_A]: 700,
  },
} as const

export default PHILIPPINES_RENI_VALUES
